import {EChannelType} from 'src/constants';

import {EVerificationError, EVerificationStatus} from './Verification/definitions';
import {EMessagingLimit, EQualityScore, EQualityStatus, EStatus, EWabaStatus} from './definitions';

export default {
  channel: 'канал',
  searchPlaceholder: 'Быстрый поиск по названию или ID канала',
  channels: 'Каналы',
  filters: {
    channelLabel: 'Канал',
    channelStatuses: 'Статус канала',
    channels: 'Каналов',
  },
  verification: {
    title: 'Запросы верификации',
    whatsappTitle: 'Запросы верификации бизнеса',
    itemTitle: 'Запрос верификации {{id}}',
    add: 'Создать запрос',
    statusLabel: 'Статус запроса',
    status: {
      [EVerificationStatus.DRAFT]: 'Черновик',
      [EVerificationStatus.MANAGER_REVIEW]: 'На проверке в edna',
      [EVerificationStatus.NEEDS_CORRECTION]: 'Требует доработки',
      [EVerificationStatus.PENDING]: 'На верификации в Meta',
      [EVerificationStatus.APPROVED]: 'Верификация пройдена',
      [EVerificationStatus.REJECTED]: 'Верификация отклонена',
      [EVerificationStatus.REJECTED_PERMANENTLY]: 'Верификация в кабинете невозможна',
    },
    error: {
      [EVerificationError.UNDEFINED_ERROR]:
        'Произошла ошибка при отправке заявки. Попробуйте ещё раз. Если ошибка повторится, обратитесь в поддержку. ',
      [EVerificationError.FAILED_TO_SUBMIT]:
        'Не удалось отправить заявку. Попробуйте ещё раз. Если ошибка повторится, обратитесь в поддержку.',
      [EVerificationError.WRONG_OBJECT_TYPE_WABA]:
        'Неверный ID компании. Проверьте данные и отправьте заявку снова. Если ошибка повторится, обратитесь в поддержку.',
      [EVerificationError.BUSINESS_INFORMATION_IS_STILL_REVIEWING]:
        'Бизнес ещё находится на проверке в Facebook. Попробуйте отправить заявку позже. Если проблема сохраняется, обратитесь в поддержку.',
    },
    businessPortfolioId: 'Идентификатор бизнес-портфолио',
    businessPortfolioIdHintOne: 'Перейдите в Бизнес-менеджер <0>→</0> Информация о компании.',
    businessPortfolioIdHintTwo:
      'Идентификатор вашего бизнес-портфеля отображается рядом с названием вашей компании.',
    websiteUrl: 'Ссылка на ваш официальный сайт',
    websiteUrlHint:
      'Предоставьте ссылку на страницу, где указаны юридическое название, адрес и номер телефона вашей компании. Убедитесь, что юридическое название, адрес и номер телефона компании полностью соответствуют данным в бизнес-портфолио и указаны в документах, загруженных для проверки компании. Этот же сайт должен быть указан в вашем бизнес-портфолио.',
    documents: 'Загрузите официальные документы',
    documentsHint:
      'Загрузите до 3 документов, подтверждающих юридическое название, адрес и номер телефона вашей компании. Максимальный размер каждого файла – 5 MB. Поддерживаемые форматы: PDF, JPEG, JPG, PNG.',
    documentsHintListTitle: 'Принимаемые документы:',
    documentsHintList: 'Принимаемые документы:',
    documentError: 'Максимально разрешённый размер файла 5 MB. Документ слишком большой.',
    documentTypes: [
      'Свидетельство о регистрации или учредительные документы',
      'Документ о регистрации или лицензии компании',
      'Налоговый документ, выданный государственным органом',
      'Выписка из банка',
      'Счет за коммунальные услуги (принимается только для подтверждения адреса и номера телефона компании)',
    ],
    documentUpload: 'Загрузить документы',
    success: {
      title: 'Запрос отправлен менеджеру',
      description:
        'edna проверит вашу заявку и отправит её в Meta на верификацию. Если понадобятся изменения в документах, ваш менеджер вернёт заявку на доработку и подскажет, что нужно исправить.',
    },
    successVerification: {
      title: 'Ваша компания успешно прошла верификацию бизнеса в Meta!',
      description: 'Поздравляем! Теперь у вас есть доступ к расширенным бизнес-функциям:',
      point1:
        'Более высокие лимиты сообщений для всех каналов WhatsApp — <0>проверьте текущие лимиты</0>',
      point2: 'Отображение названия вашей компании вместо номера телефона',
      point3:
        'Возможность запросить официальный значок верификации (зелёная галочка) — <0>следуйте инструкции</0>',
    },
    existsError: 'Уже есть заявка с таким Business Portfolio ID',
    documentsError: 'Обязательно загрузить официальные документы',
    requestRejected: 'Ваш запрос верификации отклонен',
    requestRejectedPermanently: 'Вы можете пройти верификацию самостоятельно в Meta.',
    requestRejectedAttempts:
      'Ваша заявка отклонена по следующей причине: {{reason}}.<br/>Вы можете внести необходимые изменения и подать заявку повторно. Осталось попыток: {{attempt}} из {{maxAttempts}}.',
    list: {
      editDate: 'Дата редактирования',
      businessPortfolioId: 'Business Portfolio ID',
      status: 'Статус',
      empty: 'У вас пока нет запросов',
    },
  },
  status: {
    [EStatus.DRAFT]: 'Черновик',
    [EStatus.ACTIVE]: 'Работает исправно',
    [EStatus.PROBLEM]: 'Проблема',
    [EStatus.NEEDS_ATTENTION]: 'Требует внимания',
    [EStatus.DISABLED]: 'Отключен',
    [EStatus.REGISTRATION]: 'На регистрации',
    [EStatus.CANCELED]: 'Отменен',
  },
  wabaStatus: {
    [EWabaStatus.ACCOUNT_RESTRICTION]: 'Ограничен (WABA)',
  },
  qualityStatus: {
    [EQualityStatus.FLAGGED]: 'Предупреждение',
    [EQualityStatus.RESTRICTED]: 'Ограничен',
    [EQualityStatus.CONNECTED]: 'Работает исправно',
  },
  th: {
    channelId: 'Subject ID',
    type: 'Канал',
    name: 'Название канала',
    subject: 'Отправитель',
    status: 'Статус канала',
  },
  techPartnerChannel: {
    [EChannelType.WHATSAPP]: 'Канал WhatsApp для клиента',
    [EChannelType.MAX]: 'MAX для клиента',
    [EChannelType.TELEGRAM]: 'Telegram для клиента',
    whatsAppBusinessApp: 'Канал WhatsApp Business App для клиента',
  },
  whatsAppBusinessApp: 'WhatsApp Business App',
  whatsAppBA: 'WhatsApp BA',
  changeUrl: 'Обновить ссылку',
  copyUrl: 'Скопировать ссылку',
  deleteConfirm: 'Вы уверены, что хотите удалить канал "{{name}}", без возможности восстановления?',
  successRegister: {
    head: 'Анкета зарегистрирована!',
    text: 'Анкета регистрации заполнена и отправлена, самое трудное позади!<br /><br />Теперь статусы регистрации канала будут видны в списке каналов и в карточке канала.',
  },
  empty: {
    title: 'Здесь пока пусто',
    subtitle: 'Каналов пока нет. Создайте первый канал, чтобы отправлять сообщения получателям',
  },
  editForm: {
    tariffLabel: 'Тариф для канала',
    tariffPlaceholder: 'Выберите тариф',
  },
  messages: {
    important: 'Важно!',
    needAcceptTariffs:
      'Чтобы зарегистрировать канал вы должны принять тарифы в Разделе “Тарифы” в <0>Профиле компании.</0>',
    noTariffs:
      'Для этого канала у вас нет доступных тарифов. Если вы хотите зарегистрировать канал, обратитесь к <0>вашему менеджеру</0>.',
  },
  qualityScoreLabel: 'Качество канала',
  limitLabel: 'Суточный лимит',
  messagesLimit: 'Суточный лимит исходящих сообщений',
  qualityUpdatedAt: 'Дата обновления лимита',
  activeChannel: 'Канал работает исправно',
  restrictedChannel: 'Работа канала временно ограничена',
  restrictedChannelDescription:
    'Для этого канала достигнут суточный лимит исходящих сообщений. Канал доступен только для входящих обращений.',
  flaggedChannel: 'В канале зафиксированы нарушения',
  flaggedChannelDescription:
    'На этот канал поступило много жалоб. Суточные лимиты могут быть снижены.',
  aboutLimits: 'Подробнее о лимитах',
  qualityWarning: 'Суточные лимиты могут быть снижены',
  flaggedWarning: 'Зафиксированы нарушения',
  qualityScore: {
    [EQualityScore.GREEN]: 'Высокое',
    [EQualityScore.YELLOW]: 'Среднее',
    [EQualityScore.RED]: 'Низкое',
    [EQualityScore.NA]: 'Неизвестно',
  },
  limit: {
    [EMessagingLimit.TIER_50]: '50',
    [EMessagingLimit.TIER_250]: '250',
    [EMessagingLimit.TIER_1K]: '1000',
    [EMessagingLimit.TIER_2K]: '2000',
    [EMessagingLimit.TIER_10K]: '10 000',
    [EMessagingLimit.TIER_100K]: '100 000',
    [EMessagingLimit.TIER_UNLIMITED]: 'Без ограничения',
    [EMessagingLimit.TIER_NOT_SET]: 'Неизвестен',
  },
};
